import axios, {AxiosResponse} from 'axios'
import {API_URL, Response} from '../../../../../../_metronic/helpers'
import {Stuffid} from './_models'

const STUFFID_URL = `${API_URL}/stuffid`

const getStuffidByCode = (code: string, date?: string): Promise<Stuffid | undefined> => {
  return axios
    .get(`${STUFFID_URL}/${code}?date=${date}`)
    .then((response: AxiosResponse<Response<Stuffid>>) => response.data)
    .then((response: Response<Stuffid>) => response.data)
}
export {getStuffidByCode}
